<template>
  <div class="container py-5">

    <h2 class="page-title mb-4">Cyber Security</h2>

    <p class="lead">
      Cyber Security involves protecting computers, networks, and data from
      unauthorized access, attacks, and damage.
    </p>

    <div class="card-section mt-4">
      <h4 class="section-title">🔐 What is Cyber Security?</h4>
      <p>
        It is the practice of protecting systems and networks from digital threats.
      </p>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">⚠ Common Cyber Threats</h4>
      <ul>
        <li>Virus & Malware</li>
        <li>Phishing Attacks</li>
        <li>Ransomware</li>
        <li>Hacking Attempts</li>
      </ul>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">🛡 Safety Tips</h4>
      <ul>
        <li>Use strong passwords</li>
        <li>Enable two-factor authentication</li>
        <li>Do not open unknown emails</li>
        <li>Update software regularly</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "CyberSecurity",
};
</script>

<style scoped>
.page-title { font-weight: 800; color: #2563eb; }
.lead { color: #374151; font-size: 1.1rem; }
.card-section {
  background: #fff; padding: 20px; border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-left: 4px solid #2563eb;
}
.section-title { color: #1e40af; font-weight: 600; }
</style>
